<template>
  <b-card header="Opciones de Filtro" class="card-filter">
    <b-btn class="filter-collapse" 
        variant="primary" 
        @click.prevent="showOpciones= !showOpciones">
      <i :class="showOpciones ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
    </b-btn>
    <b-collapse id="filtro" class="mt-2" v-model="showOpciones">
      <b-form>
        <b-form-group
          v-if="!noResumen"
          label="Desde"
          label-for="fechaDesde"
          :label-cols="labelCols"
          description="Cierre de Resúmen Desde"
          horizontal>
          <b-form-input 
            id="fechaDesde" 
            v-model="filtro.fechaDesde" 
            type="date">
          </b-form-input>
        </b-form-group>

        <b-form-group
          v-if="!noResumen"
          label="Hasta"
          label-for="fechaHasta"
          :label-cols="labelCols"
          description="Cierre de Resúmen Hasta"
          horizontal>
          <b-form-input 
            id="fechaHasta" 
            v-model="filtro.fechaHasta" 
            type="date">
          </b-form-input>
        </b-form-group>

        <app-banco
          label="Banco"
          :nombre="bancoNombre"
          :lista="bancosList"
          :labelCols="labelCols"
          :nullDisabled="false"
          labelOption="Todos los bancos"
          @updated="bancoActualizado">
        </app-banco>  

        <app-tarjeta-marca
          label="Marca"
          :nombre="tarjetaMarcaNombre"
          :lista="tarjetasMarcasList"
          :labelCols="labelCols"
          :nullDisabled="false"
          labelOption="Todas las tarjetas"
          @updated="tarjetaMarcaActualizada">
        </app-tarjeta-marca>  

        <!-- <app-tarjeta
          label="Tarjeta"
          :nombre="tarjetaNombre"
          :lista="tarjetasList"
          :labelCols="2"
          :nullDisabled="false"
          labelOption="Todas las tarjetas"
          @updated="tarjetaActualizada">
        </app-tarjeta> -->

        <div slot="footer">
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="filtrar">Filtrar</b-button>
        </div>
      </b-form>
    </b-collapse>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </b-card>
</template>

<script>
import Banco from '../shared/abmSelect.vue';
import TarjetaMarca from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
// import Tarjeta from '../shared/abmSelect.vue';
import moment from 'moment';

export default {
  name: 'TarjetasResumenesVencimientosFiltro',
  components: {
    appBanco: Banco,
    appTarjetaMarca: TarjetaMarca,
    appMensaje: Mensaje
    // appTarjeta: Tarjeta
  },
  mixins: [
    msjModal, 
  ],
  props: {
    noResumen: {
      type: Boolean,
      default: false
    },
    fechaDesde: {
      type: String,
      default: ''
    },
    fechaHasta: {
      type: String,
      default: ''
    },
    banco: {
      type: Object,
      default: null
    },
    tarjetaMarca: {
      type: Object,
      default: null
    },
    // tarjeta: {
    //   type: Object,
    //   default: null
    // },
  },
  data() {
    return {
      filtro: {
        fechaDesde: '',
        fechaHasta: '',
        banco: null,
        tarjetaMarca: null,
        // tarjeta: null
      },

      bancos: [],
      bancosList: [],
      tarjetasMarcas: [],
      tarjetasMarcasList: [],
      // tarjetas: [],
      // tarjetasList: [],

      showOpciones: Boolean(false),
      labelCols: 2,
      loadingBancos: false,
      loadingTarjetasMarcas: false
    }
  },
  computed: {
    bancoNombre() {
      if (this.filtro.banco) {
        if (this.filtro.banco.nombre) {
          return this.filtro.banco.nombre.trim();
        }
      }
      return null;
    },
    tarjetaMarcaNombre() {
      if (this.filtro.tarjetaMarca) {
        if (this.filtro.tarjetaMarca.nombre) {
          return this.filtro.tarjetaMarca.nombre.trim();
        }
      }
      return null;
    }
    // tarjetaNombre() {
    //   if (this.filtro.tarjeta) {
    //     if (this.filtro.tarjeta.nombre) {
    //       return this.filtro.tarjeta.nombre.trim();
    //     }
    //   }
    //   return null;
    // }
  },     
  created() {
    this.filtro.fechaDesde =  moment(this.fechaDesde).format('YYYY-MM-DD');
    this.filtro.fechaHasta = moment(this.fechaHasta).format('YYYY-MM-DD');
    this.filtro.banco = this.banco;
    this.filtro.tarjetaMarca = this.tarjetaMarca;
    // this.filtro.tarjeta = this.tarjeta;

    this.getDatosAdicionales();
  },
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    getDatosAdicionales() {
      const vm = this

      vm.loadingBancos = true;
      this.$store.dispatch('bancos/getBancosList')
        .then(() => {
          vm.bancos = this.$store.getters['bancos/bancosList']
          vm.bancosList = this.$store.getters['bancos/bancosSelectList']
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de bancos')))
        .finally(() => vm.loadingBancos = false);

      vm.loadingTarjetasMarcas = true;
      this.$store.dispatch('tarjetasmarcas/getTarjetasMarcasList')
        .then(() => {
          vm.tarjetasMarcas = this.$store.getters['tarjetasmarcas/tarjetasMarcasList']
          vm.tarjetasMarcasList = this.$store.getters['tarjetasmarcas/tarjetasMarcasSelectList']
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de marcas de tarjetas')))
        .finally(() => vm.loadingTarjetasMarcas = false);

      // vm.$store.dispatch('tarjetasPlasticos/getList')
      //   .then(() => {
      //     vm.tarjetas = this.$store.getters['tarjetasPlasticos/list'];
      //     vm.tarjetasList = this.$store.getters['tarjetasPlasticos/selectList'];
      //   })
    },
    bancoActualizado(bancoNombre) {
      if (!this.loadingBancos) {
        this.filtro.banco = null;
        if (bancoNombre) {
          this.filtro.banco = this.getSelected(this.bancos, bancoNombre);
        }
      }
    },
    tarjetaMarcaActualizada(tarjetaMarcaNombre) {
      if (!this.loadingTarjetasMarcas) {
        this.filtro.tarjetaMarca = null;
        if (tarjetaMarcaNombre) {
          this.filtro.tarjetaMarca = this.getSelected(this.tarjetasMarcas, tarjetaMarcaNombre);
        }
      }
    },
    // tarjetaActualizada(tarjetaNombre) {
    //   this.filtro.tarjeta = null;
    //   if (tarjetaNombre) {
    //     this.filtro.tarjeta = this.getSelected(this.tarjetas, tarjetaNombre);
    //   }
    // },
  },
}
</script>

<style>
</style>
